import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable } from "rxjs";
import { WebShopService } from "../services/webShop.service";
import { CoreLogService } from "../services/log.service";
import { BottomSheetHelperService } from "../services/bottomSheetHelper.service";
import { CoreLanguageService } from "../services/language.service";

@Injectable({
  providedIn: "root"
})
export class WebshopVactationGuard implements CanActivate {

  constructor(private _webshopService: WebShopService
    , private _coreLogService: CoreLogService) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const me = this;
    return new Promise<boolean>((resolve) => {
      me._webshopService.getWebshopSettingsDataModel().then(settings => {
        if (settings.vacation_notification == null || settings.vacation_notification) {
          me._webshopService.openVacationWarningDialog();
          resolve(false);
        } else {
          resolve(true);
        }
      }).catch(e => {
        me._coreLogService.error("WebshopVactationGuard.canActivate", "_webshopService.getWebshopSettingsDataModel", e);
        resolve(false);
      });
    });
  }
}
